import MapboxDraw, { DrawCustomMode, DrawCustomModeThis } from "@mapbox/mapbox-gl-draw";
import { LngLat } from "mapbox-gl";

import simpleSelect from "../../base/simpleSelect";

const { constants: Constants } = MapboxDraw;

interface DrawCustomModeState {
  dragMoving: boolean;
  initialDragPanState: boolean;
  dragMoveLocation: LngLat;
  snapList: mapboxgl.MapboxGeoJSONFeature[];
  vertices: mapboxgl.MapboxGeoJSONFeature[];
  delta: LngLat;
}

interface DrawCustomModeExtension<S> extends DrawCustomMode<S> {
  clickOnFeature(this: DrawCustomModeThis, state: S, event: MapboxDraw.MapMouseEvent): void;
}

const simpleSelectLeadIns: DrawCustomModeExtension<DrawCustomModeState> = {
  ...(simpleSelect as DrawCustomMode),

  /**
   * We overrride simpleSelect to always enter the direct_select mode
   * when clicking on a feature.
   */
  clickOnFeature: function (state, event) {
    const featureId = event.featureTarget.properties?.id;
    this.changeMode(Constants.modes.DIRECT_SELECT, {
      featureId,
    });
  },
};

export default simpleSelectLeadIns;
